import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Spinner from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import customQueryStyles from '../CustomQuery/CustomQueryStyle';
import Table from '../../components/reactTable/Table';
import startCase from 'lodash/startCase';
import { getResponseAPIData, getPostResponseAPIData, deleteResponseAPIData } from '../../services/apiService';
import { pushSavedQueryData, pushSavedQueryName, pushSavedQueryDescription, pushSavedQueryId, pushTotalBritiveQureies, pushInitialDocumentName } from '../../slices/QueriesManagerSlice';
import { pushActiveTab } from '../../slices/customQuerySlice';
import { selectButton, pushShowRelatedDta, selectedRelatedEntity, selectedRelatedDataButton, pushRunSelected, pushRunUrl, showContextualPath, pushDeleteSelectedItem, showSnackEnable, pushIsSaveAsPopUp, pushIsNavigating, pushBritSaveBtn, pushRequestBody, pushPostApiResponse, pushTableData } from '../../slices/customQueryHeaderSlice';
import { deleteChipArrayAddCriteria, pushSelectedChipArray, pushShowCard, pushChipArrayAddCriteria, pushShowTable } from '../../slices/customQueryBodySlice';
import { pushAPIData } from '../../slices/customQuerySlice';
import { pushSetLoaderComp } from '../../slices/customQueryBodySlice';
import { filterQuery } from '../../utils/Filter';
import camelCase from 'lodash/camelCase';
import consts from '../../utils/consts';
const {
  baseUrl,
  requestbody,
  baseUrlBritQuery
} = consts;
const TablePaginationComponent = withStyles({
  select: {
    border: '1px solid #ADADAD',
    borderRadius: '2px'
  }
})(TablePagination);

const BritiveQueryData = () => {
  const dispatch = useDispatch();
  const britiveQueryResponseData = useSelector(state => state.customQueryHeader.getBritQuery);
  const [tableData, setTableData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('queryname');
  const buttonsNamesArray = useSelector(state => state.customQueryHeader.buttonsNamesArray);
  const queryName = useSelector(state => state.queriesManager.queryName);
  const queryData = useSelector(state => state.queriesManager.queryData);
  const [continuePagination, setcontinuePagination] = useState(false);
  const inititalDocumentName = useSelector(state => state.queriesManager.documentName);

  const handleChangePage = (event, newPage) => {
    setTableData([]);
    setcontinuePagination(true);
    setPageNumber(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setPageNumber(0);
    setTableData([]);
    setcontinuePagination(true);
    setRowsPerPage(parseInt(event.target.value));
  };

  useEffect(() => {
    let type = 'delete';
    let data = {};
    dispatch(pushDeleteSelectedItem({
      data,
      type
    }));
    dispatch(pushIsSaveAsPopUp(false));
    dispatch(showContextualPath(false));

    if (britiveQueryResponseData && britiveQueryResponseData[0]?.data?.length > 0) {
      setTableData(britiveQueryResponseData[0]);
      setTotalCount(britiveQueryResponseData[0].headers.totalcount);
      dispatch(pushTotalBritiveQureies(britiveQueryResponseData[0].headers.totalcount));

      if (queryName != '' && queryData.queryname != '') {
        dispatch(pushSavedQueryName(queryData.queryname));
        dispatch(pushSavedQueryData(queryData));
        dispatch(pushIsNavigating(true));
      } else {
        dispatch(pushInitialDocumentName(inititalDocumentName));
      }
    }
  }, [britiveQueryResponseData]);
  useEffect(() => {
    dispatch(showSnackEnable(false));

    if (continuePagination) {
      let paginationStringOrigin = `britivequeries?limit=${rowsPerPage}&offset=${pageNumber + 1}&sortBy=${orderBy}&orderType=${order}`;
      let riskUrl = baseUrlBritQuery + paginationStringOrigin;
      dispatch(getResponseAPIData([riskUrl], 'getBritQuery'));
    }
  }, [rowsPerPage, pageNumber]);

  const generateData = () => {
    let columns = [{
      Header: 'Query Name',
      accessor: 'queryname',
      width: 200
    }, {
      Header: 'Description',
      accessor: 'description',
      width: 300
    }];
    let rows = [];

    if (britiveQueryResponseData && britiveQueryResponseData[0]?.data?.length > 0) {
      rows = britiveQueryResponseData[0].data.map(cardData => {
        return cardData;
      });
    }

    return {
      rows,
      columns
    };
  };

  const runMyQuery = index => {
    let entityName = '';
    let type = '';
    let resurl = '';
    let relatedStrings = [];
    let requestBodyParam = {};
    let selectedRelatedDataType = [];
    let relatedDataName = [];
    let entityData = '';
    entityName = tableData.data[index].entityType;
    selectedRelatedDataType = tableData.data[index].relatedEntityType.split(',');
    requestBodyParam = tableData.data[index].adaquery ? tableData.data[index].adaquery : requestbody;
    dispatch(pushRequestBody(requestBodyParam));

    if (requestBodyParam) {
      const filterArray = filterQuery(requestBodyParam, startCase(camelCase(entityName)));
      dispatch(pushSelectedChipArray([]));
      dispatch(pushChipArrayAddCriteria([]));
      dispatch(deleteChipArrayAddCriteria([]));
      dispatch(deleteChipArrayAddCriteria(filterArray));
      dispatch(pushSelectedChipArray(filterArray));
      dispatch(pushChipArrayAddCriteria(filterArray));
    }

    if (entityName === 'userAccount') {
      entityData = 'User Accounts';
    } else {
      entityData = startCase(entityName + 's');
    }

    type = entityName.toLowerCase();
    selectedRelatedDataType.forEach(relatedType => {
      if (relatedType === 'userAccount') {
        relatedStrings.push('userAccount');
        relatedDataName.push(startCase(relatedType + 's'));
      } else {
        if (relatedType) {
          relatedStrings.push(relatedType);
        }

        relatedDataName.push(startCase(relatedType + 's'));
      }
    });
    resurl = `${type}&` + (relatedStrings.length > 0 ? `relatedtypes=${relatedStrings.toString()}&` : '');
    let apiUrl = `${baseUrl}${resurl}`;
    dispatch(pushRunUrl(apiUrl));
    let paginationStringOrigin = `limit=10&offset=${pageNumber + 1}`;
    let riskUrl = apiUrl + paginationStringOrigin;
    dispatch(getPostResponseAPIData([riskUrl], requestBodyParam, 'run'));
    let arr = [];
    let relatedValues = [];
    buttonsNamesArray.map(names => {
      if (names.name === entityData) {
        names.relatedEntity.map(entities => {
          let obj = {};
          relatedDataName.forEach(entityString => {
            if (entities.name === entityString) {
              obj = { ...entities,
                isSelected: true
              };
              relatedValues.push(entities.name);
            } else if (obj.name !== entities.name) {
              obj = { ...entities,
                isSelected: false
              };
            }
          });
          arr.push(obj);
        });
      }
    });
    let data = {
      data: '',
      type: 'run'
    };
    dispatch(pushPostApiResponse(data));
    let savedata = {
      data: '',
      type: 'save'
    };
    dispatch(pushPostApiResponse(savedata));
    let queryResults = {
      data: [],
      totalCount: 0,
      totalPages: 0
    };
    dispatch(pushTableData(queryResults));
    dispatch(pushBritSaveBtn(true));
    dispatch(pushAPIData([]));
    dispatch(pushShowTable(false));
    dispatch(pushShowCard(false));
    dispatch(pushRunSelected(true));
    dispatch(pushShowRelatedDta(true));
    dispatch(selectedRelatedEntity(arr));
    dispatch(selectedRelatedDataButton(relatedValues));
    dispatch(selectButton({
      selectedName: entityData
    }));
    dispatch(pushActiveTab(2));
    dispatch(pushSavedQueryData(tableData.data[index]));
    dispatch(pushSavedQueryName(tableData.data[index].queryname));
    dispatch(pushSavedQueryDescription(tableData.data[index].description));
    dispatch(pushSavedQueryId(tableData.data[index].queryid));
    dispatch(pushSetLoaderComp(true));
  };

  const deleteMyQuery = index => {
    dispatch(deleteResponseAPIData(tableData.data[index].queryid, tableData.data[index].queryname));
  };

  const handleSortBy = sortColumn => {
    const isDsc = orderBy === sortColumn.id && order === 'desc';
    let sortOrder = isDsc === true ? 'asc' : 'desc';
    setOrder(isDsc ? 'asc' : 'desc');
    setOrderBy(sortColumn.id);
    let paginationStringOrigin = `britivequeries?limit=10&offset=${pageNumber + 1}&sortBy=${sortColumn.id}&orderType=${sortOrder}`;
    let riskUrl = baseUrlBritQuery + paginationStringOrigin;
    dispatch(getResponseAPIData([riskUrl], 'getBritQuery'));
  };

  const renderButtons = index => {
    const buttons = [/*#__PURE__*/React.createElement(Tooltip, {
      key: "Run",
      title: "Run",
      arrow: true
    }, /*#__PURE__*/React.createElement("button", {
      key: "Run",
      onClick: () => runMyQuery(index)
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-play"
    })))];
    return buttons;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, !britiveQueryResponseData?.isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    columns: generateData().columns,
    data: generateData().rows,
    handleRun: runMyQuery,
    handleDelete: deleteMyQuery,
    handleSort: handleSortBy,
    buttons: renderButtons,
    order: order,
    sortOrderBy: orderBy
  }), /*#__PURE__*/React.createElement(TablePaginationComponent, {
    rowsPerPageOptions: [10, 25, 50, 100],
    component: "div",
    count: totalCount,
    page: pageNumber,
    labelDisplayedRows: ({
      page,
      count
    }) => `Page ${page + 1} of  ${Math.ceil(count / rowsPerPage) !== 0 ? Math.ceil(count / rowsPerPage) : 1}`,
    rowsPerPage: rowsPerPage,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })) : /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    role: "status",
    style: customQueryStyles.spinnerStyle
  }));
};

export default BritiveQueryData;